import "./Chart.scss";
import {
  LineChart,
  Line,
  XAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { useState, useEffect } from "react";
import { DatePicker, ConfigProvider } from "antd";
import { useMediaQuery } from "@mui/material";

import ar_EG from "antd/es/locale/ar_EG"; // Arabic locale
import dayjs from "dayjs";
import "dayjs/locale/ar"; // Import Arabic locale for dayjs
import api from "../../utils/api";

const { RangePicker } = DatePicker;

const Chart = () => {
  const isMobile = useMediaQuery("(max-width:767px)");
  const isTablet = useMediaQuery("(min-width: 768px) and (max-width: 1024px)");

  // Set dayjs locale to Arabic
  dayjs.locale("ar");

  const [dateRange, setDateRange] = useState(null);
  const [bookingsData, setBookingsData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch bookings data on component mount and when date range changes
  useEffect(() => {
    fetchBookingsData();
  }, [dateRange]);

  // Function to fetch bookings data from the API
  const fetchBookingsData = async () => {
    setLoading(true);
    try {
      let url = "/admin/monthlyBookings";

      // Add date range parameters if selected
      if (dateRange && dateRange[0] && dateRange[1]) {
        const startDate = dateRange[0].format("YYYY-MM-DD");
        const endDate = dateRange[1].format("YYYY-MM-DD");
        url += `?startDate=${startDate}&endDate=${endDate}`;
      }

      const response = await api.get(url);

      if (response.data.status === "success") {
        // Transform the data to rename 'bookings' to 'طلب' to match the Line dataKey
        const transformedData = response.data.data.map((item) => ({
          month: item.month,
          طلب: item.bookings,
        }));

        setBookingsData(transformedData);
      } else {
        console.error("Failed to fetch bookings data:", response.data);
      }
    } catch (error) {
      console.error("Error fetching bookings data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDateRangeChange = (dates) => {
    setDateRange(dates);
  };

  return (
    <div className="chart">
      <div className="header-container">
        <p style={{ color: "#039ced", fontSize: "16px" }}>
          {new Date().getFullYear()}
        </p>
        <div className="search">
          <ConfigProvider locale={ar_EG} direction="rtl">
            <RangePicker
              format={"DD MMM"}
              style={{
                width: isMobile ? "100%" : isTablet ? "200px" : "300px",
                padding: "0px 10px",
              }}
              placeholder={["من", "الي"]}
              className="range-picker"
              onChange={handleDateRangeChange}
              value={dateRange}
              popupStyle={{ direction: "rtl" }}
              inputReadOnly={true}
            />
          </ConfigProvider>
        </div>
      </div>

      {loading ? (
        <div className="loading-container">جاري التحميل...</div>
      ) : (
        <ResponsiveContainer width="100%" aspect={4 / 1}>
          <LineChart
            data={bookingsData}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid stroke="#e0dfdf" strokeDasharray="5 5" />
            <XAxis dataKey="month" stroke="#37474F" />
            <Tooltip />
            <Line
              type="monotone"
              dataKey="طلب"
              stroke="#FDB812"
              activeDot={{ r: 8 }}
            />
          </LineChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default Chart;
